/* ---- Boot shim: force header to advertise "always" and be visible immediately ---- */
document.addEventListener('DOMContentLoaded', function () {
  var header =
    document.querySelector('.section-header') ||
    document.querySelector('.shopify-section-header') ||
    document.querySelector('#shopify-section-header') ||
    document.querySelector('header.site-header') ||
    document.querySelector('header.header') ||
    document.querySelector('header');

  if (!header) return;

  // Force the section to advertise "always" to any scripts
  if (!header.hasAttribute('data-sticky-type')) {
    header.setAttribute('data-sticky-type', 'always');
  }

  // Make sure it's visibly sticky right away
  header.classList.add('shopify-section-header-sticky');
  header.classList.remove('shopify-section-header-hidden');
});

/* ---- Global sticky manager (header + announcement) ---- */
(() => {
  const findHeader = () =>
    document.querySelector('.section-header') ||
    document.querySelector('.shopify-section-header') ||
    document.querySelector('#shopify-section-header') ||
    document.querySelector('header.site-header') ||
    document.querySelector('header.header') ||
    document.querySelector('header');

  if (!customElements.get('sticky-stack')) {
    class StickyStack extends HTMLElement {
      connectedCallback() {
        // ELEMENTS
        this.header = findHeader();
        this.announcement = document.querySelector('.announcement-bar-section');

        if (!this.header) return;

        // SETTINGS (prefer header attr, then host attr, default to 'always')
        if (!this.header.hasAttribute('data-sticky-type')) {
          this.header.setAttribute('data-sticky-type', 'always');
        }
        const headerStickyAttr = this.header.getAttribute('data-sticky-type');
        const hostStickyAttr = this.getAttribute('data-sticky-type');
        this.stickyType = headerStickyAttr || hostStickyAttr || 'always'; // 'always','reduce-logo-size','on-scroll-up','never'
        this.announcementSticky = (this.getAttribute('data-announcement-sticky') || 'true') === 'true';

        // STATE
        this.headerIsAlwaysSticky = ['always', 'reduce-logo-size'].includes(this.stickyType);
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;

        // Viewport state
        this.mql = window.matchMedia('(max-width: 767px)');
        this.isMobile = this.mql.matches;

        // Ensure visible + sticky immediately
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');

        // Announcement sticky below header
        if (this.announcement && this.announcementSticky) {
          this.announcement.classList.add('shopify-section-announcement-sticky');
        }

        // Sizing + listeners
        this.setHeights();
        this.resizeDebounce = null;
        window.addEventListener('resize', this.onResize);
        this.mql.addEventListener('change', this.onMQChange);

        // Only bind scroll logic when NOT in "always" mode
        if (!this.headerIsAlwaysSticky) {
          this.onScrollHandler = this.onScroll.bind(this);
          window.addEventListener('scroll', this.onScrollHandler, { passive: true });
          this.createObserver();
        } else {
          if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
        }

        // Safety net: strip hidden class immediately if anything adds it
        this.mo = new MutationObserver(() => {
          if (this.header.classList.contains('shopify-section-header-hidden')) {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        });
        this.mo.observe(this.header, { attributes: true, attributeFilter: ['class'] });
      }

      disconnectedCallback() {
        if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
        window.removeEventListener('resize', this.onResize);
        this.mql?.removeEventListener?.('change', this.onMQChange);
        this.mo?.disconnect();
      }

      onResize = () => {
        clearTimeout(this.resizeDebounce);
        this.resizeDebounce = setTimeout(() => this.setHeights(), 100);
      };

      onMQChange = (e) => {
        this.isMobile = e.matches;
        this.setHeights();
      };

      setHeights() {
        const headerH = this.header?.offsetHeight || 0;
        const announceH = this.announcement?.offsetHeight || 0;

        document.documentElement.style.setProperty('--sticky-header-height', `${headerH}px`);
        document.documentElement.style.setProperty('--sticky-announcement-height', `${announceH}px`);
        document.documentElement.style.setProperty(
          '--sticky-total-offset',
          `${headerH + (this.announcementSticky ? announceH : 0)}px`
        );

        // Make announcement sit under header
        if (this.announcement && this.announcementSticky) {
          this.announcement.style.setProperty('--sticky-top-offset', `${headerH}px`);
        }
      }

      createObserver() {
        // We only need bottom bound for hide/reveal threshold
        const target = this.header;
        if (!target) return;

        this.io = new IntersectionObserver((entries, obs) => {
          this.headerBounds = entries[0].intersectionRect;
          obs.disconnect();
        });
        this.io.observe(target);
      }

      onScroll() {
        if (!this.header || this.headerIsAlwaysSticky || this.isMobile) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const predictiveSearch = this.header.querySelector('predictive-search');
        if (predictiveSearch && predictiveSearch.isOpen) return;

        const threshold = this.headerBounds?.bottom ?? 0;

        if (scrollTop > this.currentScrollTop && scrollTop > threshold) {
          this.header.classList.add('scrolled-past-header');
          // Hide on scroll down (non-"always" only)
          this.hide();
        } else if (scrollTop < this.currentScrollTop && scrollTop > threshold) {
          this.header.classList.add('scrolled-past-header');
          // Reveal on scroll up
          this.reveal();
        } else if (scrollTop <= (this.headerBounds?.top ?? 0)) {
          this.header.classList.remove('scrolled-past-header');
          this.reset();
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky || this.isMobile) return;
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky || this.isMobile) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky || this.isMobile) return;
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        // keep 'shopify-section-header-sticky' so it remains sticky at top
        this.header.classList.add('shopify-section-header-sticky');
      }

      closeMenuDisclosure() {
        const disclosures = this.header?.querySelectorAll?.('header-menu') || [];
        disclosures.forEach((d) => d.close?.());
      }

      closeSearchModal() {
        const searchModal = this.header?.querySelector?.('details-modal');
        searchModal?.close?.(false);
      }
    }

    customElements.define('sticky-stack', StickyStack);
  }
})();
